import { render, staticRenderFns } from "./AdminUtilityFraudCheckQueue.vue?vue&type=template&id=eb951e42"
import script from "./AdminUtilityFraudCheckQueue.vue?vue&type=script&lang=ts"
export * from "./AdminUtilityFraudCheckQueue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports